import styles from "./styles/need-sign-in-modal.module.scss";

import React from "react";
import { useRouter } from "next/navigation";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import StyledButton from "@/components/common/styled-button";

type Props = {
  serviceName: string;
};

const NeedSignInModal = ({ serviceName }: Props) => {
  const { hideModal } = useGlobalModalContext();
  const router = useRouter();

  return (
    <div className={styles.modal}>
      <div className={styles.main_text}>
        Thank you for using <br /> <span>{serviceName}</span> of AudioModify!
      </div>
      <div className={styles.info_container}>
        You have used the trial version of the <span>{serviceName}</span>!
        Please, Sign In to use the <span>{serviceName}</span> more.
      </div>

      <StyledButton
        title={"Sign In"}
        onClick={() => {
          hideModal();
          router.push("/login");
        }}
      />
    </div>
  );
};

export default NeedSignInModal;
